import React, { Component } from 'react';
import Alert from 'components/ui/Alert';
import { Translation, withTranslation } from 'react-i18next';
import PhoneField from 'components/v2/forms/PhoneField';
import CustomerSearch from '../../site/customer-search';
import UserActionCreators from '../../../actions/UserActionCreators';
import FormCard from '../../v2/FormCard';
import SessionStore from '../../../stores/SessionStore';

function getInitialState() {
  return {
    carrier_name: '',
    carrier: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    password: '',
    username: '',
    isCustomerManager: SessionStore.isCustomerManagerAdmin(),
  };
}

class RegisterDriver extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState();
  }

  handlePhoneChange = (phone) => {
    this.setState({ phone });
  };

  handleChange(field) {
    return (e) => this.setState({ [field]: e.target.value });
  }

  handleCustomerSelect = (carrier_name, details) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        carrier_name,
        carrier: details.value,
      };
    });
  };

  handleRegister = (e) => {
    e.preventDefault();
    const { carrier_name, isCustomerManager, ...driver } = this.state;
    UserActionCreators.addDriver(driver);
    this.setState(getInitialState());
  };

  valid() {
    const { email, first_name, last_name, phone, password, username } =
      this.state;
    return !(email && first_name && last_name && phone && password && username);
  }

  renderForm() {
    const { t } = this.props;
    const isCustomerManager = this.state.isCustomerManager;
    const disabled = !this.state.carrier || !isCustomerManager;
    return (
      <FormCard
        actions={() => (
          <button
            disabled={disabled || this.valid()}
            className="button button-green"
            type="submit"
            onClick={this.handleRegister}
          >
            {t('REGISTER')}
          </button>
        )}
      >
        {!isCustomerManager && (
          <Alert type="warning">
            <Translation>
              {(t) => <p>{t('REQUIRED_CUSTOMER_MANAGER_PRIVILEGES')}</p>}
            </Translation>
          </Alert>
        )}
        <div>
          <h3 className="mb-4 text-lg font-medium text-gray-900 leading-6">
            {t('DRIVER_PROFILE')}
          </h3>
        </div>
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('FIRST_NAME')}</label>
            <input
              type="text"
              placeholder="John"
              className="w-full mb-4 form-field"
              disabled={disabled}
              onChange={this.handleChange('first_name')}
              value={this.state.first_name}
            />
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('LAST_NAME')}</label>
            <input
              type="text"
              placeholder="Smith"
              className="w-full mb-4 form-field"
              disabled={disabled}
              onChange={this.handleChange('last_name')}
              value={this.state.last_name}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('PHONE')}</label>
            <PhoneField
              value={this.state.phone}
              onChange={this.handlePhoneChange}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('USERNAME')}</label>
            <input
              type="text"
              placeholder="JohnSmith"
              className="w-full mb-4 form-field"
              disabled={disabled}
              onChange={this.handleChange('username')}
              value={this.state.username}
            />
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('EMAIL')}</label>
            <input
              type="email"
              placeholder="jsmith@cargomatic.com"
              className="w-full mb-4 form-field"
              disabled={disabled}
              onChange={this.handleChange('email')}
              value={this.state.email}
            />
          </div>

          <div className="col-span-4 sm:col-span-2">
            <label className="mb-2 form-label">{t('PASSWORD')}</label>
            <input
              type="password"
              className="block w-full mb-4 form-field"
              disabled={disabled}
              onChange={this.handleChange('password')}
              value={this.state.password}
            />
          </div>
        </div>
      </FormCard>
    );
  }

  render() {
    const { t } = this.props;
    const isCustomerManager = this.state.isCustomerManager;
    return (
      <section>
        <div className="mb-6">
          <FormCard>
            <h3 className="block mb-2 text-lg font-medium leading-6">
              {t('SELECT_A_CARRIER')}
            </h3>
            <CustomerSearch
              clearOnSelect
              onSelect={this.handleCustomerSelect}
              type="carriers"
              disabled={!isCustomerManager}
            />
          </FormCard>
        </div>
        {this.renderForm()}
      </section>
    );
  }
}

export default withTranslation()(RegisterDriver);
